// extracted by mini-css-extract-plugin
export var chip = "_90-0";
export var filterDropdown = "_90-5";
export var filterItem = "_90-6";
export var icon = "_90-1";
export var removeButton = "_90-3";
export var removeIcon = "_90-4";
export var separator = "_90-2";